import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "../utils/cropImageHelper";

const CropAvatar = ({ image, onCropped, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = async () => {
    const croppedImage = await getCroppedImg(image, croppedAreaPixels);
    onCropped(croppedImage);
  };

  return (
    <div>
      <div style={{ position: "relative", width: "100%", height: 300, background: "#333" }}>
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      </div>
      <div style={{ marginTop: "10px" }}>
        <button onClick={handleCrop}>Use Cropped Avatar</button>
        <button onClick={onCancel} style={{ marginLeft: "10px" }}>Cancel</button>
      </div>
    </div>
  );
};

export default CropAvatar;
